import React, { useEffect, useState } from 'react'
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import DateFormat from '../../../../utils/NuDate';
import { OnDownload } from '../../../../utils/OtherFunctions';
import { NormalButton } from '../../../../utils/Button';

function MRMDetailXlsx({fileName,data ,status,standardname="",review,Name,startDate,endDate,company,Module,standardId,updateLenth}) {
    const [csvData,setCSVData] = useState([])


    useEffect(()=>{
        if(data){
            let finalData = []
            data && data.map((item,index)=>{
                updateLenth(index+1)
                let tempData = {
                    "Heading":item?.heading||"",
                    "Group":item?.group_data||"",
                    "Date":item?.mom_date!=="None"&&item?.mom_date!==""&&`${DateFormat({value:item?.mom_date, format:"DD-MMM-YYYY"})}`||"",
                    "Type of Meeting":item?.type_of_meeting||"",
                    "Regrets":item?.regrets||"",
                    "Chair By":item?.chaired_by||"",
                    "Minutes By":item?.minute_by||"",
                    "Status":item?.status||"",
                    "Last Update by":item?.last_modified_name || item?.created_name || item?.created_by_name || "",
                    "Attachment Artefact":item?.attachment==true?"Yes":""
                }
                finalData.push(tempData);
            })
            setCSVData(finalData);
            
        }
    },[data])

    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const exportToCSV = (csvData, fileName) => {
      const ws = XLSX.utils.json_to_sheet(csvData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
      OnDownload(standardId,Module)

    };
    return (
      // <div onClick={()=>exportToCSV(csvData,fileName)}>ExportXls</div>
    //   <button onClick={()=>exportToCSV(csvData,fileName)}>Download</button>
     <NormalButton label='Download' handleClick={()=>exportToCSV(csvData,fileName)}/>
    )
}

export default MRMDetailXlsx;